export const LOCATION_OPTIONS = [
  { value: "NOT_US", label: "Recipient outside the US" },
  { value: "US", label: "Within the US" },
];

export const PAYMENT_METHOD_OPTIONS_OUTSIDE_US = [
  { value: "IBAN / SWIFT", label: "IBAN / SWIFT" },
];

export const PAYMENT_METHOD_OPTIONS_US = [
  { value: "ACH / Fedwire", label: "ACH / Fedwire" },
  { value: "Wire", label: "Wire" },
];

export const US_STATE_OPTIONS = [
  ["AL", "Alabama"],
  ["AK", "Alaska"],
  ["AZ", "Arizona"],
  ["AR", "Arkansas"],
  ["CA", "California"],
  ["CO", "Colorado"],
  ["CT", "Connecticut"],
  ["DE", "Delaware"],
  ["FL", "Florida"],
  ["GA", "Georgia"],
  ["HI", "Hawaii"],
  ["ID", "Idaho"],
  ["IL", "Illinois"],
  ["IN", "Indiana"],
  ["IA", "Iowa"],
  ["KS", "Kansas"],
  ["KY", "Kentucky"],
  ["LA", "Louisiana"],
  ["ME", "Maine"],
  ["MD", "Maryland"],
  ["MA", "Massachusetts"],
  ["MI", "Michigan"],
  ["MN", "Minnesota"],
  ["MS", "Mississippi"],
  ["MO", "Missouri"],
  ["MT", "Montana"],
  ["NE", "Nebraska"],
  ["NV", "Nevada"],
  ["NH", "New Hampshire"],
  ["NJ", "New Jersey"],
  ["NM", "New Mexico"],
  ["NY", "New York"],
  ["NC", "North Carolina"],
  ["ND", "North Dakota"],
  ["OH", "Ohio"],
  ["OK", "Oklahoma"],
  ["OR", "Oregon"],
  ["PA", "Pennsylvania"],
  ["RI", "Rhode Island"],
  ["SC", "South Carolina"],
  ["SD", "South Dakota"],
  ["TN", "Tennessee"],
  ["TX", "Texas"],
  ["UT", "Utah"],
  ["VT", "Vermont"],
  ["VA", "Virginia"],
  ["WA", "Washington"],
  ["WV", "West Virginia"],
  ["WI", "Wisconsin"],
  ["WY", "Wyoming"],
  ["DC", "District of Columbia"],
].map(([value, label]) => ({ value, label }));

export const ACCOUNT_HOLDER_TYPE_OPTIONS = [
  { value: "Individual", label: "Individual" },
  { value: "Corporate", label: "Corporate / Business" },
];

export const RELATIONSHIP_OPTIONS = [
  { value: "vendor", label: "Vendor / Supplier" },
  { value: "partner", label: "Business Partner" },
  { value: "client", label: "Client" },
  { value: "self", label: "Self" },
];
